import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../../../types/form/field-format-type';
import { passwordFieldConfigValidator } from '../../../../../types/form/field-validation-config';
import { defaultPasswordRules } from '../../../../../types/form/password-rule';
export const defaultOccFormFieldValidationConfig = {
    password: {
        type: FieldFormatType.Password,
        required: true,
        maxLength: 64,
        rules: defaultPasswordRules
    }
};
export const occFormFieldValidationConfigValidator = Validator.object({
    password: passwordFieldConfigValidator
});
